import { faCaretDown, faCheckCircle, faTimesCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";
import React from "react";

import { Img } from "@/mk2/components/Img";
import useEventCallback from "@/mk2/hooks/useEventCallback";
import { BZ2_FACET_CATS } from "@/mk/autogenerated/translations/CategoryFacet.060a11dea93c8d7191037c9bf17c538d";
import { getLabel } from "@/mk/bazaar/product/categories";
import assetUrl from "@/mk/common/assetUrl";

import styles from "./CategoryFacet.mscss";

export interface OwnProps {
    className?: string;
    dimmed?: boolean;
    selected: string;
    isFilter?: boolean;
    canClear?: boolean;

    onToggle();
    onClear();
}

type Props = OwnProps;

const CategoryFacet: React.FunctionComponent<Props> = ({
    className,
    dimmed = false,
    selected = null,
    isFilter = true,
    canClear = true,
    onToggle,
    onClear,
}) => {
    const onToggleCallback = useEventCallback(() => {
        onToggle();
    }, [onToggle]);
    const onClearCallback = useEventCallback(() => {
        onClear();
    }, [onClear]);

    return (
        <div className={cx(styles.CategoryFacet, className)}>
            {selected && canClear && (
                <div className={styles.CategoryFacet__clear} onClick={onClearCallback}>
                    <div
                        className={cx(
                            styles.CategoryFacet__clear__icon,
                            !isFilter && styles["CategoryFacet__clear__icon--select"],
                        )}
                    >
                        <FontAwesomeIcon icon={faTimesCircle} />
                    </div>
                </div>
            )}
            <div
                className={cx(
                    styles.CategoryFacet__wrapper,
                    selected && styles["CategoryFacet__wrapper--hasValue"],
                    selected && !isFilter && styles["CategoryFacet__wrapper--hasValue--select"],
                )}
                onClick={onToggleCallback}
                data-cy="bazaar-category-facet"
            >
                {dimmed && <div className={styles.CategoryFacet__dimmed} />}
                <div
                    className={cx(
                        styles.CategoryFacet__label,
                        selected && styles["CategoryFacet__label--selected"],
                    )}
                >
                    <span className={cx(styles.CategoryFacet__label__container)}>
                        {selected ? (
                            <span className={cx(styles.CategoryFacet__selected__label)}>
                                {getLabel(selected)}
                            </span>
                        ) : (
                            <>
                                <span className={cx(styles.CategoryFacet__selected__icon)}>
                                    <Img
                                        className={styles.CategoryFacet__selected__icon__image}
                                        src={assetUrl + "img/icons/bazaar/categories_v2@2x.png"}
                                        width={22}
                                        height={15}
                                    />
                                </span>
                                <span className={cx(styles.CategoryFacet__selected__label)}>
                                    {BZ2_FACET_CATS}
                                </span>
                            </>
                        )}
                    </span>
                    <div className={styles.CategoryFacet__mask} />
                    <div
                        className={cx(
                            styles.CategoryFacet__label__icon,
                            isFilter || !selected
                                ? styles["CategoryFacet__label__icon--filter"]
                                : styles["CategoryFacet__label__icon--select"],
                        )}
                    >
                        <FontAwesomeIcon
                            icon={isFilter || !selected ? faCaretDown : faCheckCircle}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

CategoryFacet.displayName = "CategoryFacet";

export default React.memo<Props>(CategoryFacet);
